import { Link } from "react-router-dom";
import { useLenis } from "lenis/react";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/motion";
import { NewsCard } from "@/components/site/NewsCard";
import { NEWS } from "@/lib/news";
import { Seo, SITE } from "@/components/site/Seo";

export default function News() {
  const lenis = useLenis();
  return (
    <div className="App min-h-screen bg-white" data-testid="news-page">
      <Seo
        title="News & Announcements — OpenDegree"
        description="Partnership announcements, platform updates and company news from OpenDegree as we build the connected education platform."
        path="/news"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListElement: NEWS.map((n, i) => ({
            "@type": "ListItem", position: i + 1,
            item: { "@type": "NewsArticle", headline: n.title, datePublished: n.date, description: n.excerpt, author: { "@type": "Organization", name: "OpenDegree" } },
          })),
        }}
      />
      <Navbar />
      <main className="mx-auto max-w-7xl px-5 sm:px-8 pt-36 pb-28">
        <Reveal>
          <Link
            to="/"
            data-testid="news-back-link"
            onClick={() => lenis && lenis.scrollTo(0)}
            className="inline-flex items-center gap-2 text-sm font-medium text-slatey hover:text-ink transition-colors duration-200"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </Reveal>
        <Reveal delay={0.05}>
          <p className="mt-10 text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">News & Announcements</p>
          <h1 className="mt-4 font-display text-4xl sm:text-6xl font-extrabold tracking-tighter text-ink leading-[0.98]">
            Company news & updates
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slatey">
            Partnership announcements, platform updates and company news as we build the OpenDegree admissions platform.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {NEWS.map((item, i) => (
            <NewsCard key={item.id} item={item} delay={(i % 3) * 0.07} testid={`news-page-card-${i}`} />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
